import { Checkbox } from 'antd';
import { getShopPackageSkuList } from 'api/shop';
import { addCartGoodsList } from 'api/user';
import { useAddAnimation } from 'hooks/useAddAnimation';
import useUrl from 'hooks/useUrl';
import IconArrowUp from 'icons/icon-arrow-up.svg';
import immer from 'immer';
import { PriceContext, UserContext } from 'libs/contexts';
import { MmuDataType } from 'libs/enums';
import { formatPrice } from 'libs/utils';
import { useContext, useEffect, useRef, useState } from 'react';
import { cls } from 'reactutils';
import AreaEmptyData from './AreaEmptyData';
import Container from './Container';
import LoginModal from './LoginModal';
import { NavConfigProps } from './ShopModuleNav';
import ShopProductDetailAttribute from './ShopProductDetailAttribute';

type ShopDataType = {
  uiConfig: { type: string; jsonConfig: any }[];
  navigationSetting: { jsonConfig: NavConfigProps };
  [key: string]: any;
};

type RowProps = {
  name: string;
  mainImage: string;
  bestSkuSalesPrice: number;
  [key: string]: any;
}[];

type ListProps = {
  name: string;
  rows: RowProps;
}[];

function handleClick(data) {
  window.open(`/product/detail?id=${data.sysNo}`);
}

export default function ShopModulePackage({ shopData }: { shopData: ShopDataType }) {
  const [list, setList] = useState<DeepNullable<ListProps>>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showIndex, setShowIndex] = useState();
  const attrRef = useRef(null);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [checkList, setCheckList] = useState([]);
  // ani
  const playTargetRef = useRef<any>(null);
  const playSrcRef = useRef<any>(null);
  const playStar = useAddAnimation(playSrcRef, playTargetRef, {
    width: '70px',
    height: '70px',
  });
  const priceData = useContext(PriceContext);
  const { showPrice, tip } = priceData;
  const userInfo = useContext(UserContext);
  const { getPublicUrl } = useUrl();

  const combineList = async () => {
    let skuSysNoList = [];
    let packageList = [];
    let sort = 1;
    shopData.uiConfig
      ?.filter((v) => v.type === 'packagePurchase')
      ?.forEach((v) => {
        if (v.jsonConfig.rows) {
          packageList.push(...v.jsonConfig.rows);
        }
      });
    console.log('🚀 ~ ?.forEach ~ packageList', packageList);

    // console.log(packageList)
    packageList?.forEach((v1, i) => {
      if (i === 0) {
        sort = v1.showSort;
      }
      // 两层rows, 第一层套餐, 第二层套餐内商品
      v1.rows.forEach((v2) => {
        if (!skuSysNoList.includes(v2.sysNo)) {
          skuSysNoList.push(v2.sysNo);
        }
      });
    });
    if (skuSysNoList?.length > 0) {
      const res = await getShopPackageSkuList({
        json: {
          skuSysNoList,
          sort,
        },
      });
      const skuList = res.data;
      const sortPackageList = packageList?.sort((a, b) => a.priority - b.priority);
      const newSkuList = immer(sortPackageList, (draft) => {
        draft.forEach((v, i) => {
          const row = draft[i];
          // 两层rows, 第一层套餐, 第二层套餐内商品
          row?.rows?.forEach((v2, i2) => {
            const item = skuList?.find((v3) => v3.sysNo === v2.sysNo);
            row.rows[i2] = item;
          });
          row.rows = row.rows?.filter((v) => v && v.areaCanSale);
          if (v.showSort === 1) {
            row.rows.sort((a, b) => b.sellCount - a.sellCount);
          }
          if (v.showSort === 2) {
            row.rows.sort((a, b) => a.salesPrice - b.salesPrice);
          }
        });
      });
      setList(newSkuList);
    }
  };
  useEffect(() => {
    // console.log("shopData", shopData)
    combineList();
  }, [shopData]);

  useEffect(() => {
    playTargetRef.current = document.querySelector('.cart-box');
  }, []);

  const onCheck = (i) => {
    const index = checkList.findIndex((v) => v === `${activeIndex}${i}`);
    if (index > -1) {
      setCheckList(checkList.filter((v) => v !== `${activeIndex}${i}`));
    } else {
      setCheckList([...checkList, `${activeIndex}${i}`]);
    }
  };

  const chooseAttr = (e, i) => {
    e.stopPropagation();
    setShowIndex(i);
  };

  const changeTab = (i) => {
    setActiveIndex(i);
  };

  useEffect(() => {
    const hideDom = (e) => {
      if (!attrRef?.current?.contains(e?.target)) {
        setShowIndex(null);
      }
    };
    document.addEventListener('click', hideDom);
    return () => {
      document?.removeEventListener('click', hideDom);
    };
  }, []);

  // attr panel

  const mmuText = (v, key) => {
    let text = '';
    v[key]?.forEach((c) => {
      const key = c.attributeName;
      const val = c.categoryAttributeValueList?.find((a) => a.active)?.attributeValue ?? '';
      const prefix = c.categoryAttributeValueList?.find((a) => a.active)?.prefix ?? '';
      const suffix = c.hasCustomize
        ? c.categoryAttributeValueList?.find((a) => a.active)?.suffix ?? ''
        : '';
      if (val || val === 0) {
        text += `${key}:${prefix}${val}${suffix}; `;
      }
    });
    return text;
  };

  const handleChangeAttr = async (r, i) => {
    query(
      {
        skuSysNoList: [r.sysNo],
      },
      i,
    );
  };

  const handleChangeMmu = async (mmu, i, attributeIndex) => {
    const mmuAttributeList = immer(list[activeIndex].rows[i].mmuAttributeList, (draft) => {
      draft[attributeIndex] = mmu;
    });

    query(
      {
        skuSysNoList: [list[activeIndex].rows[i].sysNo],
        mmuAttributeList,
      },
      i,
    );
  };

  const query = async (json, i) => {
    const res = await getShopPackageSkuList({
      json,
    });
    const newSkuList = immer(list, (draft) => {
      draft[activeIndex].rows[i] = res.data?.[0];
    });
    setList(newSkuList);
  };

  const checkChoose = (v) => {
    return checkList.includes(`${activeIndex}${v}`);
  };

  const handleMmu = (list) => {
    if (list?.length > 0) {
      const arr = list.map((v) => {
        if (
          v.hasCustomize &&
          v.hasRequired &&
          [MmuDataType.TEXT, MmuDataType.FLOAT, MmuDataType.INT].includes(v.dataType)
        ) {
          return {
            ...v,
            categoryAttributeValueList: v.categoryAttributeValueList?.map((c) => ({
              ...c,
              attributeValue: c.attributeValue ? c.attributeValue : 0,
              active: true,
            })),
          };
        } else {
          return v;
        }
      });
      return arr;
    }
    return [];
  };

  const addCart = async () => {
    if (!userInfo) {
      setLoginModalVisible(true);
      return;
    }

    if (checkList?.length > 0) {
      const arr = [];
      list.forEach((item, i1) => {
        item.rows.forEach((v, i2) => {
          if (checkList.includes(`${i1}${i2}`)) {
            arr.push({
              mallSkuSysNo: v.sysNo,
              mmuAttributeList: handleMmu(v.mmuAttributeList),
              quantity: v.buyStep,
            });
          }
        });
      });
      await addCartGoodsList(arr);
      const index = checkList[0]?.substr(1);
      const imgEle = document.querySelectorAll('.product-img')[index] as HTMLImageElement;

      playStar(
        (start_top, _start_left, end_top, _end_left) => Math.min(start_top, end_top),
        imgEle,
      );
    }

    // location.replace("/shopping_cart")
  };

  const isAllCheck = () => {
    return list[activeIndex]?.rows?.every((_v, i) => checkList.includes(`${activeIndex}${i}`));
  };

  const chooseAll = () => {
    const isAll = isAllCheck();
    if (isAll) {
      setCheckList(checkList.filter((c) => +c.substr(0, 1) !== activeIndex));
    } else {
      const arr = [];
      list[activeIndex]?.rows?.forEach((_c, i) => {
        if (!checkList.includes(`${activeIndex}${i}`)) {
          arr.push(`${activeIndex}${i}`);
        }
      });
      setCheckList([...checkList, ...arr]);
    }
  };

  const jumpLogin = () => {
    setLoginModalVisible(false);
    location.href = `/sso/xlogin?return_url=${encodeURIComponent(location.href)}`;
  };

  return (
    <>
      {list?.length > 0 && (
        <div className="tab-box">
          <Container>
            <div className="tab-wrap">
              {list.map((v, i) => (
                <div
                  className={cls('tab', i === activeIndex && 'active')}
                  key={i}
                  onClick={() => changeTab(i)}
                >
                  {v.name}
                </div>
              ))}
            </div>
          </Container>
        </div>
      )}
      <Container>
        <div className="content">
          <div className="card-box">
            {list?.[activeIndex]?.rows?.length > 0 ? (
              <>
                {list?.[activeIndex]?.rows?.map((v, i) => (
                  <div key={i} className="card">
                    <div className="check">
                      <Checkbox checked={checkChoose(i)} onChange={() => onCheck(i)} />
                    </div>
                    {v.imageProductTag?.map((item, index) => (
                      <div className="grid-img-tag" key={index}>
                        {item.tagName}
                      </div>
                    ))}
                    <img
                      src={getPublicUrl(v.mainImage)}
                      className="product-img"
                      alt={v.name}
                      onClick={() => handleClick(v)}
                    />
                    <div className="name">
                      {v.titleProductTag?.map((item, index) => (
                        <div key={index} className="grid-title-tag">
                          {item.tagName}
                        </div>
                      ))}
                      {v.name}
                    </div>
                    {/* <CheckButton name={v.name} active={true} /> */}
                    <div
                      className={cls('attr', showIndex === i && 'attr-active')}
                      onClick={(e) => chooseAttr(e, i)}
                    >
                      <span className="attr-text">
                        {mmuText(v, 'attributeList')}
                        {mmuText(v, 'mmuAttributeList')}
                      </span>
                      <span className={cls('arrow-icon')}>
                        <IconArrowUp />
                      </span>
                      {showIndex === i && (
                        <div
                          className="pop-over"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          {v.attributeList?.map((attribute, attributeIndex) => (
                            <ShopProductDetailAttribute
                              isMmu={false}
                              attribute={attribute}
                              key={attributeIndex}
                              onChange={(r) => handleChangeAttr(r, i)}
                            />
                          ))}
                          {v.mmuAttributeList?.map((attribute, attributeIndex) => (
                            <ShopProductDetailAttribute
                              isMmu={true}
                              attribute={attribute}
                              key={attributeIndex}
                              onChange={(r) => handleChangeMmu(r, i, attributeIndex)}
                            />
                          ))}
                          <div className="pop-btn" onClick={() => setShowIndex(null)}>
                            确定
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="price">
                      <span>￥</span>
                      {showPrice ? (
                        <>
                          <span className="text">{formatPrice(v.salesPrice)}</span>
                          <span className="separator"> / </span>
                          <span className="unit">{v.unitName}</span>
                        </>
                      ) : (
                        <span className="text">{tip}</span>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <AreaEmptyData height="200px" />
            )}
          </div>

          {list?.length > 0 ? (
            <div className="btn-box">
              <Checkbox onChange={chooseAll} checked={isAllCheck()}>
                全选
              </Checkbox>
              <div className="right">
                <div className="num">
                  已选 <span>{checkList?.length}</span> 件商品
                </div>
                <div className="btn" onClick={addCart} ref={playSrcRef}>
                  一键加入购物车
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Container>
      <LoginModal
        visible={loginModalVisible}
        onOk={jumpLogin}
        onCancel={() => setLoginModalVisible(false)}
      />

      <style jsx>{`
        .tab-box {
          width: 100%;
          height: 42px;
          border-bottom: 2px solid var(--shop-primary-color);
        }
        .tab-wrap {
          display: flex;
          align-items: center;
        }
        .tab {
          height: 42px;
          display: flex;
          align-items: center;
          padding: 14px 30px;
          cursor: pointer;
          font-size: 14px;
          color: #333333;
          font-weight: 500;
        }
        .active {
          background-color: var(--shop-primary-color);
          color: var(--shop-primary-text-color);
        }
        .card-box {
          display: flex;
          width: 100%;
          gap: 32px;
          flex-wrap: wrap;
          padding: 32px 0;
        }
        .card {
          background: #ffffff;
          border-radius: 8px;
          width: 276px;
          height: 438px;
          padding: 20px;
          position: relative;
        }
        .product-img {
          width: 236px;
          height: 236px;
          cursor: pointer;
        }
        .content :global(.ant-checkbox-checked .ant-checkbox-inner) {
          background-color: var(--shop-primary-color);
          border-color: var(--shop-primary-color);
        }
        .content :global(
          .ant-checkbox-checked::after,
          .ant-checkbox-wrapper: hover .ant-checkbox-inner,
          .ant-checkbox: hover .ant-checkbox-inner,
          .ant-checkbox-input: focus + .ant-checkbox-inner
        ) {
          border-color: var(--shop-primary-color);
        }
        .check {
          width: 100%;
          text-align: right;
          margin-bottom: 10px;
        }
        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 16px;
          color: #222222;
          width: 235px;
          height: 44px;
          margin-top: 17px;
        }
        .attr {
          border: 1px solid #e7e7e7;
          border-radius: 2px;
          width: 236px;
          height: 32px;
          display: flex;
          align-items: center;
          padding: 0 10px;
          cursor: pointer;
          position: relative;
          font-size: 16px;
          color: #666666;
        }
        .attr-active {
          border-bottom-left-radius: 0;
          border-bottom: none;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        }
        .attr .pop-over {
          min-width: 236px;
          position: absolute;
          z-index: 9;
          top: 31px;
          left: -1px;
          width: fit-content;
          background: #ffffff;
          border: 1px solid #e7e7e7;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
          border-radius: 2px;
          border-top-left-radius: 0;
          padding: 10px;
          box-sizing: border-box;
          padding-top: 5px;
          max-height: 300px;
          overflow-y: auto;
        }
        .attr-active::after {
          content: "";
          display: block;
          width: 234px;
          height: 5px;
          background-color: #ffffff;
          bottom: -1px;
          left: 0;
          position: absolute;
          z-index: 9;
        }
        .item {
          white-space: nowrap;
          display: flex;
        }
        .arrow-icon {
          display: inline-block;
          vertical-align: middle;
          width: 12px;
          height: 12px;
          line-height: 12px;
          text-align: center;
          transform: rotate(180deg);
          transition: transform 0.3s ease;
          position: absolute;
          right: 10px;
          top: 10px;
        }
        .arrow-icon :global(svg path) {
          fill: #666666;
        }
        .attr-active .arrow-icon {
          transform: rotate(0deg);
          top: 7px;
        }
        .price {
          font-size: 16px;
          color: #fa5401;
          letter-spacing: 0;
          line-height: 22px;
          font-weight: 500;
          margin-top: 10px;
        }
        .price span {
          font-size: 14px;
        }
        .btn-box {
          background: #ffffff;
          border-radius: 8px;
          height: 64px;
          display: flex;
          justify-content: space-between;
          padding-left: 20px;
          align-items: center;
          margin-bottom: 40px;
        }
        .right {
          display: flex;
          gap: 36px;
          height: 64px;
          align-items: center;
        }
        .num {
          font-size: 12px;
          color: #999999;
        }
        .num span {
          font-size: 16px;
          color: #fa5401;
          letter-spacing: 0;
          font-weight: 500;
        }
        .btn {
          font-size: 16px;
          color: #ffffff;
          font-weight: 500;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--shop-primary-color);
          border-radius: 0 8px 8px 0;
          height: 64px;
          padding: 0 36px;
          cursor: pointer;
        }
        .attr-text {
          width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          white-space: nowrap;
        }
        .pop-btn {
          border-radius: 2px;
          background: var(--shop-primary-color);
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 124px;
          height: 38px;
          cursor: pointer;
          margin-left: 80px;
          margin-top: 15px;
          margin-bottom: 15px;
        }
        .grid-img-tag,
        .grid-title-tag {
          font-size: 12px;
          color: #fff;
          line-height: 1;
          display: inline-block;
        }
        .grid-img-tag {
          position: absolute;
          top: 60px;
          left: 26px;
          background-color: rgba(245, 34, 45, 0.9);
          padding: 4px 6px 3px;
          z-index: 8;
        }
        .grid-title-tag {
          padding: 3px;
          background: var(--primaryColor);
          border-radius: 1px;
          margin-right: 7px;
          z-index: 8;
          transform: translateY(-2px);
        }
      `}</style>
    </>
  );
}
